export class MenuConfig {
  public defaults: any = {
    header: {
      self: {},
      items: [
        {
          title: 'Dashboards',
          root: true,
          alignment: 'left',
          page: '/admin',
          translate: 'MENU.DASHBOARD',
        },
      ],
    },
    aside: {
      self: {},
      items: [
        {
          title: 'Trang Chủ',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          page: '/admin',
          translate: 'MENU.DASHBOARD',
          bullet: 'dot',
        },
        {
          section: 'Đối Tượng',
        },
        {
          title: 'Quản Lý Người Dùng',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-user-outline-symbol',
          page: '/admin/user',
        },
        {
          title: 'Quản Lý phòng ban',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-building',
          page: '/admin/department',
        },
        {
          title: 'Quản lý nhóm tham dự họp',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-browser-2',
          page: '/admin/group-meeting',
        },
        { section: 'Quản Lý Chung' },
        {
          title: 'Quản Lý Lịch Họp',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-calendar-check',
          page: '/admin/schedule',
        },
        {
          title: 'Quản Lý Nhóm Tài Liệu',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-file-pdf',
          page: '/admin/attachment-type',
        },
        {
          title: 'Quản Lý Lịch Họp Mẫu',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-calendar-check',
          page: '/admin/schedule-template',
        },        
        {
          title: 'Cấu Hình Website',
          bullet: 'dot',
          icon: 'fas fa-cogs',
          root: true,
          submenu: [
            {
              title: 'Cấu Hình Chung',
              page: '/admin/setting',
            },
            {
              title: 'Banner và Favicon',
              page: '/admin/setting/setting-image',
            },
            {
              title: 'Cấu hình Email & SMS mặc định',
              page: '/admin/setting/setting-email',
            }
          ],
        },
        {
          title: 'Quản Lý mẫu tiêu đề lịch',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-synagogue',
          page: '/admin/title-template',
        },
        {
          title: 'Quản Lý địa điểm',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-map-marker-alt',
          page: '/admin/location',
        },
        {
          title: 'Quản Lý Tin Tức',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-newspaper',
          page: '/admin/post',
        },
        {
          title: 'Gửi tin nhắn SMS',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-sms',
          page: '/admin/schedule/send-sms',
        },
        {
          title: 'Quản Lý email logs',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-envelope',
          page: '/admin/email-logs',
        },
        {
          title: 'Thống kê lịch họp',
          root: true,
          bullet: 'dot',
          icon: 'fas fa-chart-bar',
          submenu: [
            {
              title: 'Theo ngày',
              page: '/admin/statistical',
            },
            {
              title: 'Theo tháng',
              page: '/admin/statistical/month',
            },
            {
              title: 'Theo Năm',
              page: '/admin/statistical/year',
            },
          ],
        },
      ],
    },
  };

  public get configs(): any {
    return this.defaults;
  }
}
